import { useState, useEffect, useCallback } from 'react';
import { WellsFargoSettingsApi } from '@/api/clients/wells-fargo-settings/wells-fargo-settings.api';

export const useGetWellsFargoWebhookSubscription = (organizationId) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSubscription = useCallback(async () => {
    if (!organizationId) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const response = await WellsFargoSettingsApi.getWebhookSubscription(
        organizationId,
      );
      setData(response.data);
    } catch (err) {
      setError(err);
      console.error('Failed to load Wells Fargo webhook subscription', err);
    } finally {
      setLoading(false);
    }
  }, [organizationId]);

  useEffect(() => {
    fetchSubscription();
  }, [fetchSubscription]);

  return {
    data,
    setData,
    loading,
    error,
    refetch: fetchSubscription,
  };
};
